import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Integração',
  loadError: 'Não foi possível carregar a integração',
  state: {
    active: 'Ativa',
    revoked: 'Chave revogada',
  },
  period: 'Período dos números',
  last30Days: 'Últimos 30 dias',
  total: 'Total',
  revoked: {
    title: 'A chave foi revogada pela equipe Bodyprint',
    text: 'As chamadas à API voltam 401 e nenhuma notificação nova sai para os atletas. Os números mostram o período em que ela esteve ativa.',
  },
  privacy: {
    title: 'Só números agregados',
    text: 'O portal nunca mostra quem são os atletas. Os dados de cada um chegam só pela API, para quem tem a chave.',
  },
} satisfies TranslationTree;
